import { steps } from "@/mocks/manga";
import SectionTitle from "./SectionTitle";

export default function Steps() {
  return (
    <section id="steps" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionTitle
          eyebrow="使用流程"
          title="四步开启你的追更体验"
          desc="从注册到安心阅读，只需四步。无需反复刷新，更新提醒与自动续读全程护航。"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <div key={s.title} className="relative rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="font-heading text-4xl text-primary-200">{String(i + 1).padStart(2, "0")}</span>
              <div className="mt-4 flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className={`${s.icon} text-xl`}></i>
              </div>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}